import { render, staticRenderFns } from "./Rect.vue?vue&type=template&id=ab07d45e&scoped=true&"
import script from "./Rect.vue?vue&type=script&lang=js&"
export * from "./Rect.vue?vue&type=script&lang=js&"
import style0 from "./Rect.vue?vue&type=style&index=0&id=ab07d45e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab07d45e",
  null
  
)

export default component.exports